import { ListItem, ListItemText } from "@mui/material";

type QMResultProp = {
  result: string;
};

export const QMResult = (props: QMResultProp) => {
  const { result } = props;
  const successStyle = {
    borderColor: "#198025",
  };
  const failStyle = {
    borderColor: "#D92121",
  };
  const isSuccess = (result: string) => result === "Pass";
  const style = {
		borderWidth: "3px",
		borderStyle: "solid",
		borderRadius: "10px",
    ...(isSuccess(result)
      ? {
          ...successStyle,
        }
      : {
          ...failStyle,
        }),
    width: "8rem",
  };
  return (
    <ListItem sx={style}>
			<ListItemText primary="Result: " secondary={result} />
    </ListItem>
  );
};
